// Client item number filters (PD-17505). The customer's Item Numbers tab is
// served by ClientItemNumbersService, which reads this key off the filters
// blob itself (joinType 'custom').

import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

const CLIENT_ITEM_NUMBER_LIST_KEYS = ['client-item-numbers-embedded'];

export const clientItemNumberFilters: FilterRegistry = {
	clientItemNumberKeywords: {
		...createKeywordFilter({
			label: 'Search',
			placeholder: 'Their number, their description or our item',
			objectTable: 'client_item',
			listKeys: CLIENT_ITEM_NUMBER_LIST_KEYS,
		}),
		queryMapping: { objectTable: 'client_item', joinType: 'custom' },
		queryParamName: 'clientItemNumberKeywords',
	},
};
